<div
  *ngIf="attachment"
  matRipple
  (click)="openAttachment()"
  class="rounded-full bg-white flex items-center pr-2 cursor-pointer transition-all duration-500">
  <div class="bg-grey/80 z-20 border rounded-full h-10 w-10 flex items-center justify-center">
    @if (getAttachmentIcon() !== 'doc') {
      <mat-icon [svgIcon]="getAttachmentIcon()"></mat-icon>
    } @else {
      <mat-icon>attachment</mat-icon>
    }
  </div>
  <div class="flex items-center gap-2 -ml-2 pl-3 pr-2 py-1.5 rounded-r-full bg-grey/60">
    <div class="">{{ attachment.fileName }}</div>
    <mat-progress-spinner *ngIf="isLoading" [diameter]="25" color="primary" mode="indeterminate"></mat-progress-spinner>
  </div>
</div>
